import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Link,
} from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  CssBaseline,
  ThemeProvider,
  createTheme,
  Box,
  useMediaQuery,
} from "@mui/material";
//---------------- Styles---------------- 
// import './stylesheet.css'; // Removed - using Tailwind CDN in index.html
import './toggleSwitch.css';
import './App.css';
import './ButtonStyle.css';
import './loding.css';

//---------------- Auth---------------- 
import { AuthProvider, useAuth } from "./AuthContext";

//---------------- Permission Route---------------- 
import PermissionRoute from "./components/common/PermissionRoute";

//---------------- Navbar + Logout---------------- 
import HorizontalNavbar from "./HorizontalNavbar";
import MobileBottomNav from "./MobileBottomNav";
import Logout from "./Logout";

//---------------- PWA Components---------------- 
import PWAStatus from "./components/common/PWAStatus";

//---------------- Service Worker Registration---------------- 
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';

//---------------- Styles---------------- 
// import './stylesheet.css'; // Removed - using Tailwind CDN in index.html
import './toggleSwitch.css';
import './App.css';
import './ButtonStyle.css';
import './loding.css';
import LodingComponent from "./loding";
// import Loginlogo from "./Loginlogo.png";

//---------------- Logo---------------- 
import BpsLogo from "./components/pages/Logo/BpsGlobal.jpeg";

//-----------SessionTimeOut---------
import SessionTimeout from "./SessionTimeout";

//-----------Company----------------
import CompanyEdit from "./components/pages/Company/Edit";

//-----------Home-------------------
import Home from "./components/pages/Home";
//-----------Role-------------------
import RoleIndex from "./components/pages/Role/Index";
import RoleDetail from "./components/pages/Role/Detail";

//-----------UserPermission-------------------
import UserPermissionIndex from "./components/pages/UserPermission/UserPermissionIndex";

//-----------User-------------------
import UserIndex from "./components/pages/User/Index";
import UserCreate from "./components/pages/User/Create";
import UserEdit from "./components/pages/User/Edit";
import UserDetail from "./components/pages/User/Detail";
import PasswordChange from "./components/pages/User/PasswordChange";

//-----------Product-------------------
import ProductCategoryIndex from "./components/pages/ProductCategory/Index";
import ProductItemIndex from "./components/pages/ProductItem/Index";
import ProductBrandIndex from "./components/pages/ProductBrand/Index";
import ProductRelationIndex from "./components/pages/ProductRelation/Index";

//-----------TermsAndConditions-------------------
import TermsAndConditionsIndex from "./components/pages/TermsAndConditions/Index";

//-----------Bank-------------------
import BankIndex from "./components/pages/Bank/Index";

//-----------Master-------------------
import MasterDashboard from "./components/pages/Master/MasterDashboard";
import ClientIndex from "./components/pages/Master/ClientIndex";
import VendorIndex from "./components/pages/Master/VendorIndex";

//-----------AccountHead-------------------
import AccountHeadDashboard from "./components/pages/AccountHead/AccountHeadDashboard";
import AccountHeadIndex from "./components/pages/AccountHead/AccountHeadIndex";
import AssetIndex from "./components/pages/AccountHead/AssetIndex";
import CapitalIndex from "./components/pages/AccountHead/CapitalIndex";
import OtherOptionIndex from "./components/pages/AccountHead/OtherOptionIndex";
import BalanceSheetHeadIndex from "./components/pages/AccountHead/BalanceSheetHeadIndex";

//-----------PurchaseOrder-------------------
import PurchaseOrderIndex from "./components/pages/PurchaseOrder/PurchaseOrderIndex";

//-----------Purchase-------------------
import PurchaseIndex from "./components/pages/Purchase/PurchaseIndex";

//-----------PurchaseReturn-------------------
import PurchaseReturnAgainstIndex from "./components/pages/PurchaseReturn/PurchaseReturnAgainstIndex";

//-----------SaleReturn-------------------
import SaleReturnAgainstIndex from "./components/pages/SaleReturn/SaleReturnAgainstIndex";

//-----------Quotation-------------------
import QuotationIndex from "./components/pages/Quotation/QuotationIndex";

//-----------SalesOrder-------------------
import SalesOrderIndex from "./components/pages/SaleOrder/SalesOrderIndex";

//-----------Sale-------------------
import SaleIndex from "./components/pages/Sale/SaleIndex";
//-----------SaleReturn-------------------
// import SaleIndex from "./components/pages/Sale";

//-----------Stock-------------------
import StockTransferInIndex from "./components/pages/Stock/StockTransferInIndex";
import StockTransferOutIndex from "./components/pages/Stock/StockTransferOutIndex";

//-----------PaymentReceipts-------------------
import PaymentReceiptsIndex from "./components/pages/PaymentReceipts/PaymentReceiptsIndex";

//-----------JournalEntry-------------------
import JournalEntryIndex from "./components/pages/JournalEntry/JournalEntryIndex";

//-----------PettyCash-------------------
import PettyCashIndex from "./components/pages/PettyCash/PettyCashIndex";

//-----------Report-------------------
import TrialBalance from "./components/pages/Report/TrialBalanceReport";
import LedgerReport from "./components/pages/Report/LedgerReport";
import VendorDueListReport from "./components/pages/Report/VendorDueListReport";
import CustomerDueListReport from "./components/pages/Report/CustomerDueListReport";
import OutstandingReport from "./components/pages/Report/OutstandingReport";
import VendorAgingReport from "./components/pages/Report/VendorAgingReport";
import CustomerAgingReport from "./components/pages/Report/CustomerAgingReport";
import PurchasePartyandItemWiseReport from "./components/pages/Report/PurchasePartyandItemWiseReport";
import SalePartyandItemWiseReport from "./components/pages/Report/SalePartyandItemWiseReport";
import CashBook from "./components/pages/Report/CashBook";
import StockReport from "./components/pages/Report/StockReport";
import DetailedInvoiceReport from "./components/pages/Report/DetailedInvoice";
import IncomeExpenseSummaryReport from "./components/pages/Report/IncomeExpenseSummaryReport";

//-----------PettyCashReport-------------------
import PettyCashReport from "./components/pages/Report/PettyCashReports";
//-----------Staff-------------------
import StaffDashboard from "./components/pages/Staff/StaffDashboard";

//-----------Department-------------------
import DepartmentIndex from "./components/pages/Department/DepartmentIndex";

//-----------Designation-------------------
import DesignationIndex from "./components/pages/Designation/DesignationIndex";
import TrialBalanceReport from "./components/pages/Report/TrialBalanceReport";
import TrialBalanceAdvancedReport from "./components/pages/Report/TrialBalanceAdvancedReport";

// ---------------- Theme ---------------- //
const theme = createTheme({
  palette: {
    primary: {
      main: "#6366f1", // Modern Indigo
      dark: "#4f46e5",
      light: "#e0e7ff",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#10b981", // Emerald
      dark: "#047857",
      light: "#d1fae5",
      contrastText: "#ffffff",
    },
    background: {
      default: "#f8fafc",
      paper: "#ffffff",
    },
  },
  typography: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          textTransform: "none",
          fontWeight: 600,
          transition: "all 0.2s ease-in-out",
          "&:hover": {
            transform: "translateY(-1px)",
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: "none",
        },
      },
    },
  },
});

//const Sidebar = ({ open, roleName }) => {
// ---------------- Layout ---------------- //
const Layout = () => {
  const { companyName, roleName, username, isAuthenticated } = useAuth();
  const isMobile = useMediaQuery('(max-width:768px)');

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        {/* Session Timeout Component - only render when authenticated */}
        {isAuthenticated && <SessionTimeout />}

        {/* PWA Status Component */}
        <PWAStatus
          showInstallPrompt={true}
          showUpdatePrompt={true}
          showOfflineStatus={true}
        />

        {/* Header with integrated menu */}
        <AppBar
          position="fixed"
          sx={{
            zIndex: (t) => t.zIndex.drawer + 1,
            background: "rgba(15, 23, 42, 0.95)",
            backdropFilter: "blur(12px)",
            borderBottom: "1px solid rgba(255, 255, 255, 0.08)",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)"
          }}
        >
          <Toolbar sx={{ minHeight: '48px !important', height: '48px', px: 2 }}>
            {/* BPS Logo and Company Name */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <img
                src={BpsLogo}
                alt="BPS Logo"
                style={{
                  height: '34px',
                  width: 'auto',
                  objectFit: 'contain',
                  borderRadius: '50px',
                  border: '1.5px solid rgba(255, 255, 255, 0.2)',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.15)'
                }}
              />
              <Typography
                variant="h6"
                sx={{ 
                  fontWeight: 700, 
                  textTransform: "uppercase",
                  letterSpacing: "0.5px"
                }}
              >
                <Link to="/Home" style={{ textDecoration: "none", color: "inherit" }}>
                  <span style={{ fontFamily: "'Inter', sans-serif", fontSize: '13px' }}>{companyName}</span>
                </Link>
              </Typography>
            </Box>

            {/* Navigation Menu - Desktop only */}
            {!isMobile && username !== "Counter" && <HorizontalNavbar />}

            {/* Spacer */}
            <Box sx={{ flexGrow: 1 }} />

            {/* Logout icon only */}
            <Logout />
          </Toolbar>
        </AppBar>

        {/* Content */}
        <Box
          sx={{
            pt: '48px',
            pb: isMobile ? '70px' : 0, // Add padding for bottom nav on mobile
            minHeight: '100vh',
            backgroundColor: '#f8fafc',
          }}
        >
          <Box sx={{ p: 0 }}>
            <Switch>
              <Route path="/" exact component={Home} />
              <Route path="/Home" exact component={Home} />

              {/* Administration - Role */}
              <PermissionRoute path="/RoleIndex" component={RoleIndex} requiredPermissions={["Read Administration"]} />
              <PermissionRoute path="/RoleDetail/:id" component={RoleDetail} requiredPermissions={["Read Administration"]} />

              {/* Administration - User Permissions */}
              <PermissionRoute path="/UserPermissionIndex" component={UserPermissionIndex} requiredPermissions={["Read Administration"]} />

              {/* Administration - User */}
              <PermissionRoute path="/UserIndex" component={UserIndex} requiredPermissions={["Read Administration"]} />
              <PermissionRoute path="/UserCreate" component={UserCreate} requiredPermissions={["Create Administration"]} />
              <PermissionRoute path="/UserEdit/:id" component={UserEdit} requiredPermissions={["Edit Administration"]} />
              <PermissionRoute path="/UserDetail/:id" component={UserDetail} requiredPermissions={["Read Administration"]} />
              <PermissionRoute path="/PasswordChange" component={PasswordChange} requiredPermissions={["Edit Administration"]} />

              {/* Master - Product */}
              <PermissionRoute path="/ProductCategoryIndex" component={ProductCategoryIndex} requiredPermissions={["Read Master"]} />
              <PermissionRoute path="/ProductItemIndex" component={ProductItemIndex} requiredPermissions={["Read Master"]} />
              <PermissionRoute path="/ProductBrandIndex" component={ProductBrandIndex} requiredPermissions={["Read Master"]} />
              <PermissionRoute path="/ProductRelationIndex" component={ProductRelationIndex} requiredPermissions={["Read Master"]} />

              {/* Master - Terms & Conditions */}
              <PermissionRoute path="/TermsAndConditionsIndex" component={TermsAndConditionsIndex} requiredPermissions={["Read Master"]} />

              {/* Master - Bank */}
              <PermissionRoute path="/BankIndex" component={BankIndex} requiredPermissions={["Read Master"]} />

              {/* Master */}
              <PermissionRoute path="/MasterDashboard" component={MasterDashboard} requiredPermissions={["Read Master"]} />
              <PermissionRoute path="/ClientIndex" component={ClientIndex} requiredPermissions={["Read Master"]} />
              <PermissionRoute path="/VendorIndex" component={VendorIndex} requiredPermissions={["Read Master"]} />

              {/* Master - AccountHead */}
              <PermissionRoute path="/AccountHeadDashboard" component={AccountHeadDashboard} requiredPermissions={["Read Master"]} />
              <PermissionRoute path="/AccountHeadIndex" component={AccountHeadIndex} requiredPermissions={["Read Master"]} />
              <PermissionRoute path="/AssetIndex" component={AssetIndex} requiredPermissions={["Read Master"]} />
              <PermissionRoute path="/CapitalIndex" component={CapitalIndex} requiredPermissions={["Read Master"]} />
              <PermissionRoute path="/OtherOptionIndex" component={OtherOptionIndex} requiredPermissions={["Read Master"]} />
              <PermissionRoute path="/BalanceSheetHeadIndex" component={BalanceSheetHeadIndex} requiredPermissions={["Read Master"]} />

              {/* Transaction - PurchaseOrder */}
              <PermissionRoute path="/PurchaseOrderIndex" component={PurchaseOrderIndex} requiredPermissions={["Read Transaction"]} />

              {/* Transaction - Purchase */}
              <PermissionRoute path="/PurchaseIndex" component={PurchaseIndex} requiredPermissions={["Read Transaction"]} />

              {/* Transaction - PurchaseReturn */}
              <PermissionRoute path="/PurchaseReturnAgainstIndex" component={PurchaseReturnAgainstIndex} requiredPermissions={["Read Transaction"]} />

              {/* Transaction - Quotation */}
              <PermissionRoute path="/QuotationIndex" component={QuotationIndex} requiredPermissions={["Read Transaction"]} />

              {/* Transaction - SalesOrder */}
              <PermissionRoute path="/SaleOrderIndex" component={SalesOrderIndex} requiredPermissions={["Read Transaction"]} />

              {/* Transaction - Sale */}
              <PermissionRoute path="/SaleIndex" component={SaleIndex} requiredPermissions={["Read Transaction"]} />

              {/* Transaction - SaleReturn */}
              <PermissionRoute path="/SaleReturnAgainstIndex" component={SaleReturnAgainstIndex} requiredPermissions={["Read Transaction"]} />

              {/* Transaction - Stock */}
              <PermissionRoute path="/StockTransferInIndex" component={StockTransferInIndex} requiredPermissions={["Read Transaction"]} />
              <PermissionRoute path="/StockTransferOutIndex" component={StockTransferOutIndex} requiredPermissions={["Read Transaction"]} />

              {/* Accounts - PaymentReceipts */}
              <PermissionRoute path="/PaymentAndReceiptIndex" component={PaymentReceiptsIndex} requiredPermissions={["Read Accounts"]} />

              {/* Accounts - JournalEntry */}
              <PermissionRoute path="/JournalEntryIndex" component={JournalEntryIndex} requiredPermissions={["Read Accounts"]} />

              {/* Accounts - PettyCash */}
              <PermissionRoute path="/PettyCashIndex" component={PettyCashIndex} requiredPermissions={["Read Accounts"]} />

              {/* Reports */}
              <PermissionRoute path="/TrialBalanceReport" component={TrialBalanceReport} requiredPermissions={["Read Reports"]} />
              <PermissionRoute path="/TrialBalanceAdvancedReport" component={TrialBalanceAdvancedReport} requiredPermissions={["Read Reports"]} />
              <PermissionRoute path="/CashBook" component={CashBook} requiredPermissions={["Read Reports"]} />
              <PermissionRoute path="/Ledger" component={LedgerReport} requiredPermissions={["Read Reports"]} />
              <PermissionRoute path="/VendorDueList" component={VendorDueListReport} requiredPermissions={["Read Reports"]} />
              <PermissionRoute path="/CustomerDueList" component={CustomerDueListReport} requiredPermissions={["Read Reports"]} />
              <PermissionRoute path="/Outstanding" component={OutstandingReport} requiredPermissions={["Read Reports"]} />
              <PermissionRoute path="/VendorAging" component={VendorAgingReport} requiredPermissions={["Read Reports"]} />
              <PermissionRoute path="/CustomerAging" component={CustomerAgingReport} requiredPermissions={["Read Reports"]} />
              <PermissionRoute path="/PurchasePartyandItemWiseReport" component={PurchasePartyandItemWiseReport} requiredPermissions={["Read Reports"]} />
              <PermissionRoute path="/SalePartyandItemWiseReport" component={SalePartyandItemWiseReport} requiredPermissions={["Read Reports"]} />
              <PermissionRoute path="/StockReport" component={StockReport} requiredPermissions={["Read Reports"]} />
              <PermissionRoute path="/DetailedInvoiceReport" component={DetailedInvoiceReport} requiredPermissions={["Read Reports"]} />
              <PermissionRoute path="/IncomeExpenseSummary" component={IncomeExpenseSummaryReport} requiredPermissions={["Read Reports"]} />
              <PermissionRoute path="/PettyCashReport" component={PettyCashReport} requiredPermissions={["Read Reports"]} />


              {/* Master - Company */}
              <PermissionRoute path="/CompanyEdit" component={CompanyEdit} requiredPermissions={["Read Administration"]} />

              {/* Staff / Department / Designation */}
              <PermissionRoute path="/StaffDashboard" component={StaffDashboard} requiredPermissions={["Read Administration"]} />
              <PermissionRoute path="/DepartmentIndex" component={DepartmentIndex} requiredPermissions={["Read Master"]} />
              <PermissionRoute path="/DesignationIndex" component={DesignationIndex} requiredPermissions={["Read Master"]} />

            </Switch>
          </Box>
        </Box>

        {/* Mobile Bottom Navigation */}
        {isMobile && username !== "Counter" && <MobileBottomNav />}
      </Router>
    </ThemeProvider>
  );
};

// ---------------- Root ---------------- //
const App = () => {
  // Service worker disabled
  // useEffect(() => {
  //   // Register service worker with enhanced features
  //   serviceWorkerRegistration.register({
  //     onSuccess: (registration) => {
  //       console.log('SW registered successfully');
  //     },
  //     onUpdate: (registration) => {
  //       console.log('SW update available');
  //     }
  //   });

  //   // Handle PWA install prompt
  //   const handleBeforeInstallPrompt = (e) => {
  //     e.preventDefault();
  //     window.deferredPrompt = e;
  //   };

  //   const handleAppInstalled = () => {
  //     console.log('PWA was installed');
  //     window.deferredPrompt = null;
  //   };

  //   window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
  //   window.addEventListener('appinstalled', handleAppInstalled);

  //   return () => {
  //     window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
  //     window.removeEventListener('appinstalled', handleAppInstalled);
  //   };
  // }, []);

  return (
    <Router>
      <AuthProvider>
        <Layout />
      </AuthProvider>
    </Router>
  );
};
export default App;
